/**
 * Returns the image URL suffix used to load an image at a specific size.
 *
 * Pass the image width and either its height or aspect ratio.
 * If you only pass the width, we assume a ratio of 2 / 3.
 *
 * @param {object} dimensions - Dimensions of the image that the URL suffix is generated for
 * @param {number} dimensions.width - The width that the image will usually have on the page
 * @param {number} [dimensions.height] - The height that the image will usually have on the page
 * @param {number} [dimensions.aspectRatio = 2 / 3] - The aspect ratio that the image will have on the page
 * @returns {string} Suffix for thumbnail image URLs
 */

function getImageUrlSuffix({width, height, aspectRatio = 2 / 3}) {
	if (!width) return null;

	return `/w_${width},h_${height || Math.floor(width * aspectRatio)}`;
}

export default getImageUrlSuffix;
